import { setupConfig } from "@ionic/core";
import "@ionic/pwa-elements";
import "@stencil/redux";
// tslint:disable-next-line: no-duplicate-imports
import "jeep-sqlite";
import {
  applyPolyfills,
  defineCustomElements as jeepSqlite,
} from "jeep-sqlite/loader";
import mapboxgl from "mapbox-gl";

import { CONFIGS } from "../config";
import { initSentry } from "../services/sentry.service";

mapboxgl.accessToken = CONFIGS.prod.MAPBOX_TOKEN;

export default async () => {
  /**
   * The code to be executed should be placed within a default function that is
   * exported by the global script. Ensure all of the code in the global script
   * is wrapped in the function() that is exported.
   */

  setupConfig({
    mode: "ios",
    spinner: "crescent",
    swipeBackEnabled: false,
    innerHTMLTemplatesEnabled: true,
  });

  // Initialize Sentry as early as possible
  initSentry();
};

setTimeout(() => {
  applyPolyfills().then(() => {
    jeepSqlite(window);
  });
})
